<sb-dashboard-widget
  [isLoading]="isLoading()"
  [isEmpty]="schedules().length === 0"
  [title]="'My schedule' | translate"
  [emptySettings]="{
    description: 'No shifts yet - once assigned, they\'ll show up here.' | translate,
    icon: 'calendar-time-add-cute-re',
  }"
>
  <sb-dashboard-widget-select
    [options]="periodOptions"
    [model]="widgetPeriod()"
    (modelChange)="onPeriodChange($event)"
    [label]="'Next' | translate"
  />
  <table class="table-widget table-uniform-rows">
    <thead>
      <tr>
        <th class="row-20">{{ 'Date' | translate }}</th>
        <th class="row-20">{{ 'Time' | translate }}</th>
        <th class="row-20">{{ 'Location' | translate }}</th>
        <th class="row-20">{{ 'Team' | translate }}</th>
        <th class="row-20">{{ 'Department' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      @for (schedule of schedules(); track schedule.occurrence_id) {
        <tr
          class="cursor-pointer"
          role="link"
          [routerLink]="['', { outlets: { modal: ['schedule-shift', schedule.occurrence_id] } }]"
        >
          <td>{{ schedule.date | localeDate: 'medium' }}</td>
          <td>
            <span>{{ schedule.starttime | time }}</span>
            @if (!schedule.hide_end_time) {
              <span> - {{ schedule.endtime | time }}</span>
            }
          </td>
          <td>{{ schedule.location_name }}</td>
          <td>{{ schedule.Team?.name }}</td>
          <td>{{ schedule.department_name }}</td>
        </tr>
      }
    </tbody>
  </table>
</sb-dashboard-widget>
